import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["className"];
import { Button } from '@carnica/ui-kit';
import React from 'react';
import { defineUrlIcon } from '@carnica/graphics';
import { cnBem } from "../../../../shared/lib";
import styles from "../Form/styles.pcss";
var Icon = defineUrlIcon({
  url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDE2Ljg3NVYzLjEyNSIgc3Ryb2tlPSIjMjgzMDNGIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00LjM3NSA4Ljc1TDEwIDMuMTI1TDE1LjYyNSA4Ljc1IiBzdHJva2U9IiMyODMwM0YiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cgo=',
  ratio: 1
});
var IconSubmit = function IconSubmit(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    size: 20,
    "data-t-id": "ui-SubmitButton"
  }));
};
var cnForm = cnBem('form', styles);
export var SubmitButton = function SubmitButton(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    "aria-label": "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    className: cnForm('submit', [className]),
    iconLeft: IconSubmit,
    onlyIcon: true,
    size: "m"
  }));
};